<template>
  <div>
    <v-bottom-sheet v-model="contact">
      <v-sheet class="text-center pt-2" height="105px">
        <v-row class="px-3">
          <v-col class="compact">
            <a target="_blank" href="mailto:contact@i2e1.com" class="contact-link">
              <img height="36px" src="~/img/icons/email.svg" />
              <br />Email
            </a>
          </v-col>
          <v-col>
            <a
              target="_blank"
              href="https://wa.me/918880322222?text=I'm%20facing%20issues%20with%20my%20hotspot"
              class="contact-link"
            >
              <img height="36px" src="~/img/icons/whatsapp.png" />
              <br />Whatsapp
            </a>
          </v-col>
          <v-col class="compact">
            <a target="_blank" href="tel:+918880322222" class="contact-link">
              <img height="36px" src="~/img/icons/call.svg" />
              <br />Call
            </a>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
    <v-card>
      <v-card-title class="headline">Troubleshoot</v-card-title>
      <v-card-text>
        Your device seems
        <b>Not Working</b>. Follow below steps to make it
        <b>Work:</b>
        <ol>
          <li>
            Check if the
            <u>lights</u> for
            <b>Power</b>,
            <b>Internet</b>, and
            <b>Wi-Fi</b> are ON for both
            devices
          </li>
          <li>Check if your main internet is working</li>
          <li>
            Check if the
            <u>LAN cable</u> is connected to the WAN port of the
            <b>WIOM device</b>
            and the LAN port of your
            <b>internet device</b>
          </li>
        </ol>
        <br />To confirm if your Guest Wi-Fi is working: Try to connect to the
        WIOM Wi-FI
        <br />
        <br />
        <span style="font-size: 12px; text-transform:italics;">
          If it is still not working, email us at
          <u>
            <a href="mailto:contact@i2e1.com">contact@i2e1.com</a>
          </u> or call us at
          <u>
            <a href="tel:+918880322222">+91-8880322222</a>
          </u>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          large
          color="#333"
          text
          @click="$emit('cancel')"
          style="padding: 5px 20px 5px 20px;"
        >Cancel</v-btn>
        <v-btn
          large
          style="font-weight:400;margin:0px 10px 10px 25px;;color:#fff;border-radius:3px !important;padding: 5px 20px 5px 20px;"
          id="submit"
          depressed
          @click="showContact()"
        >Contact Us</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["showTroubleShooting"],
  data: function() {
    return {
      contact: false
    };
  },
  methods: {
    showContact: function() {
      this.contact = true;
    }
  }
};
</script>
